var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#24275C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1579 21.481H10.8421C10.3705 21.481 10 21.8648 10 22.3534V29.6816C10 30.1702 10.3705 30.554 10.8421 30.554H41.1579C41.6295 30.554 42 30.1702 42 29.6816V22.3534C42 21.8648 41.6295 21.481 41.1579 21.481ZM16.4674 25.2847L14.3116 27.6576C14.2105 27.7972 14.0421 27.867 13.84 27.867C13.6716 27.867 13.5032 27.7972 13.3684 27.6576L12.2568 26.4013C12.0211 26.1222 12.0211 25.7034 12.2905 25.4591C12.56 25.2149 12.9642 25.2149 13.2 25.494L13.8737 26.2269L15.5579 24.3774C15.7937 24.0982 16.1979 24.0982 16.4674 24.3425C16.7032 24.5867 16.7368 25.0055 16.4674 25.2847ZM40.3158 28.8092H33.7579V23.2258H40.3495V28.8092H40.3158Z",
    fill: "#2EC5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8421 19.0731H33.0063C33.4779 19.0731 33.8484 18.6892 33.8484 18.2007V10.8724C33.8484 10.3839 33.4779 10 33.0063 10H10.8421C10.3705 10 10 10.3839 10 10.8724V18.1658C10 18.6543 10.3705 19.0731 10.8421 19.0731ZM18.7242 11.7448H32.1642V17.3282H18.7242V11.7448Z",
    fill: "#8C30F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8863 32.9619H10.8421C10.3705 32.9619 10 33.3458 10 33.8343V41.1277C10 41.6162 10.3705 42.0001 10.8421 42.0001H27.8863C28.3579 42.0001 28.7284 41.6162 28.7284 41.1277V33.8343C28.7284 33.3807 28.3579 32.9619 27.8863 32.9619ZM27.0442 40.2902H18.7242V34.7067H27.0442V40.2902Z",
    fill: "#D6B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.06e680334c103a68c28ca9867913e9e9.svg";
export { ForwardRef as ReactComponent };